import { Endpoint } from './base/endpoints';
import { useBaseService } from './base/useBaseService';

export default function useDistractor(itemId?: string) {
  return useBaseService(
    {
      queryKey: ['distractors', itemId],
      endpoints: {
        get: Endpoint.getDistractions,
        create: Endpoint.addDistraction,
        delete: Endpoint.deleteDistraction,
        update: Endpoint.updateDistraction,
      },
      enabled: !!itemId,
    },
    itemId || ''
  );
}
